/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_content_delivery_bucket": "clickfrenzy-fe-application-prod",
    "aws_content_delivery_bucket_region": "ap-southeast-2",
    "aws_content_delivery_url": "https://dc0ylyku9sdex.cloudfront.net",
    "aws_cognito_identity_pool_id": "ap-southeast-2:1fbe6e31-9abf-4fe6-82a6-33310ff0ee16",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_t9TY9DxRD",
    "aws_user_pools_web_client_id": "6uhpf8nh5ebcab8121miunttvb",
    "oauth": {
        "domain": "cf-fed-auth-prod.auth.ap-southeast-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://clickfrenzy.com.au",
        "redirectSignOut": "https://clickfrenzy.com.au/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "clickfrenzyFeNotifications",
            "endpoint": "https://93zt20kdo6.execute-api.ap-southeast-2.amazonaws.com/prod",
            "region": "ap-southeast-2"
        },
        {
            "name": "clickfrenzyPreview",
            "endpoint": "https://6k4vdljeec.execute-api.ap-southeast-2.amazonaws.com/prod",
            "region": "ap-southeast-2"
        },
        {
            "name": "clickfrenzyFeEmarsys",
            "endpoint": "https://opjmc9hj26.execute-api.ap-southeast-2.amazonaws.com/prod",
            "region": "ap-southeast-2"
        },
        {
            "name": "clickfrenzyFeUsers",
            "endpoint": "https://os1xaty967.execute-api.ap-southeast-2.amazonaws.com/prod",
            "region": "ap-southeast-2"
        },
        {
            "name": "clickfrenzyFeDecrypt",
            "endpoint": "https://ybfce9t5nd.execute-api.ap-southeast-2.amazonaws.com/prod",
            "region": "ap-southeast-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://3ds2mmsiunc6rdokd6nryxxoge.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "clickfrenzy-public-data-prod",
    "aws_user_files_s3_bucket_region": "ap-southeast-2"
};


export default awsmobile;
